import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URLS } from 'src/app/config/api-urls';

@Injectable({
  providedIn: 'root'
})
export class ReportsApiService {
  private http = inject(HttpClient);


  private freeTrialReportUrl = API_URLS.FREE_TRIAL_REPORT;

  exportFreeTrialReport() {
    return this.http.get(this.freeTrialReportUrl, { responseType: 'blob' });
  }
}
